<template src="./register.html"></template>

<script>
import axios from 'axios'
  const TURNSTILE_SCRIPT = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'

  function loadTurnstileScript () {
    if (typeof window === 'undefined') return Promise.resolve()
    if (window.turnstile) return Promise.resolve()
    if (window.__smardieTurnstileLoading) return window.__smardieTurnstileLoading

    window.__smardieTurnstileLoading = new Promise(function (resolve, reject) {
      const existing = document.querySelector('script[data-smardie-turnstile]')
      if (existing) {
        existing.addEventListener('load', function () { resolve() })
        existing.addEventListener('error', function () { reject(new Error('Failed to load security check')) })
        return
      }
      const script = document.createElement('script')
      script.src = TURNSTILE_SCRIPT
      script.async = true
      script.defer = true
      script.setAttribute('data-smardie-turnstile', '1')
      script.onload = function () { resolve() }
      script.onerror = function () { reject(new Error('Failed to load security check')) }
      document.head.appendChild(script)
    })

    return window.__smardieTurnstileLoading
  }

  export default {
    data: function () {
      return {
        registrant: {
          contact_name: '',
          company: '',
          email: ''
        },
        // Public site key (Spin widget). Override with VUE_APP_TURNSTILE_SITE_KEY if needed.
        turnstileSiteKey: (process.env.VUE_APP_TURNSTILE_SITE_KEY || '0x4AAAAAAEEpU46qUegaOJR3').trim(),
        turnstileToken: '',
        turnstileWidgetId: null,
        submitting: false
      }
    },
    mounted: function () {
      this.mountTurnstile()
    },
    beforeUnmount: function () {
      this.destroyTurnstile()
    },
    // Vue 2 compat
    beforeDestroy: function () {
      this.destroyTurnstile()
    },
    methods: {
      mountTurnstile: function () {
        const self = this
        if (!this.turnstileSiteKey) return

        loadTurnstileScript().then(function () {
          self.$nextTick(function () {
            if (!self.$refs.turnstileContainer || !window.turnstile) return
            self.destroyTurnstile()
            self.turnstileWidgetId = window.turnstile.render(self.$refs.turnstileContainer, {
              sitekey: self.turnstileSiteKey,
              action: 'turnstile-spin-v2',
              theme: 'auto',
              callback: function (token) {
                self.turnstileToken = token || ''
              },
              'expired-callback': function () {
                self.turnstileToken = ''
              },
              'error-callback': function () {
                self.turnstileToken = ''
              }
            })
          })
        }).catch(function (err) {
          console.warn(err && err.message ? err.message : err)
        })
      },
      destroyTurnstile: function () {
        if (this.turnstileWidgetId != null && window.turnstile && typeof window.turnstile.remove === 'function') {
          try { window.turnstile.remove(this.turnstileWidgetId) } catch (e) { /* ignore */ }
        }
        this.turnstileWidgetId = null
        this.turnstileToken = ''
      },
      resetTurnstile: function () {
        this.turnstileToken = ''
        if (this.turnstileWidgetId != null && window.turnstile && typeof window.turnstile.reset === 'function') {
          try { window.turnstile.reset(this.turnstileWidgetId) } catch (e) { /* ignore */ }
        }
      },
      register: function () {
        if (this.submitting) return
        if (!(this.registrant.contact_name || '').trim() || !(this.registrant.email || '').trim()) {
          this.errorNotification('Please fill in Your Name and Email Address')
          return
        }

        if (this.turnstileSiteKey && !this.turnstileToken) {
          this.errorNotification('Please complete the security check')
          return
        }

        const userData = {
          contact_name: this.registrant.contact_name.trim(),
          email: this.registrant.email.trim(),
          company: (this.registrant.company || '').trim(),
          turnstile_token: this.turnstileToken || ''
        }

        this.submitting = true
        axios.post('/api/auth/register', userData).then(response => {
          this.$router.push({ path: '/confirm-email', query: { email: userData.email } })
        }).catch(error => {
          this.resetTurnstile()
          const data = error.response && error.response.data
          const message = (data && (data.message || data.error)) || 'Failed to create account. Please try again.'
          this.errorNotification(typeof message === 'string' ? message : (data && data.error) || 'Failed to create account. Please try again.')
        }).finally(() => {
          this.submitting = false
        })
      }
    }
  }
</script>

<style>
.register-turnstile-field {
  display: flex;
  justify-content: left;
  margin: 0.5rem 0 1rem;
}

.register-turnstile {
  min-height: 65px;
}
</style>
